<template>
  <div class="TL_BookSession">

    <h1>Stats</h1>
    <div class="md-layout md-gutter">
      <!-- show a card to display event stats -->
      <md-card class="Card md-layout-item md-gutter">
        <md-card-header>
          <div class="md-title">Events</div>
        </md-card-header>

        <md-card-content>
          <md-list>
            <md-list-item>
              <md-icon>event</md-icon>
              <p class="md-list-item-text">
                <span>{{ thisYear }}: {{eventStats.eventsByYear[thisYear]}}</span>
                <small>{{ lastYear }}: {{eventStats.eventsByYear[lastYear]}} <em v-if="eventStats.eventsByYear[lastYear] > 0">({{(((eventStats.eventsByYear[thisYear] - eventStats.eventsByYear[lastYear]) / eventStats.eventsByYear[lastYear]) * 100).toFixed(2)}}%)</em></small>
              </p>
            </md-list-item>
          </md-list>
          <chart :data="eventStats.eventsByWeek" />
        </md-card-content>
      </md-card>

      <md-card class="Card md-layout-item md-gutter">
        <md-card-header>
          <div class="md-title">Tickets</div>
        </md-card-header>

        <md-card-content>
          <md-list>
            <md-list-item>
              <md-icon>ticket</md-icon>
              <p class="md-list-item-text">
                <span>{{ thisYear }}: {{eventStats.ticketsByYear[thisYear]}}</span>
                <small>{{ lastYear }}: {{eventStats.ticketsByYear[lastYear]}} <em v-if="eventStats.ticketsByYear[lastYear] > 0">({{(((eventStats.ticketsByYear[thisYear] - eventStats.ticketsByYear[lastYear]) / eventStats.ticketsByYear[lastYear]) * 100).toFixed(2)}}%)</em></small>
              </p>
            </md-list-item>
          </md-list>
          <chart :data="eventStats.ticketsByWeek" />
        </md-card-content>
      </md-card>
    </div>

    <hr>
    <h2>Dashboard proposed features</h2>
    <ul>
      <li>Events on today/tomorrow/this week</li>
      <li>Biggest event organisers (most events/tickets on sale/sold)</li>
      <li>no. of organisers</li>
      <li>new organisers/ sign up rate</li>
      <li>Average organiser value</li>
      <li>Most popular events</li>
      <li>Potential issues:
        <ul>
          <li>Last ticket sale date/time</li>
          <li>Last event created date/time</li>
          <li>Log errors? Rollbar/Laravel</li>
        </ul>
      </li>
    </ul>
    <h2>Functionality</h2>
    <ul>
      <li>Refund ticket</li>
      <li>First party registration for API</li>
      <li>Payments</li>
      <li>User management</li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import errorModel from '../models/error';
import cookieModel from '../models/cookie';
import Chart from "../components/chart/chart";
import Vue from 'vue';

export default {
  components: {
    Chart
  },
  mounted() {
    this.init()
  },
  props: {},
  methods: {
    // do search
    init: function () {
      const vm = this;
      let url = this.baseUrl + "/einstein/stats";

      // reset error message
      vm.asyncFormError = '';
      let postData = {};

      // Add authorisation to request header
      vm.axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + cookieModel.getCookie('ticketlab_access');

      // Do a call to the search api for guest name
      vm.axiosInstance.post(url, postData)
        .then(function (response) {
          if (response.data) {
            // reset error
            vm.asyncFormError = false;
            vm.previousSearch = vm.search;
            vm.searchResults = response.data;
            vm.disableForm = false;

            vm.createChartData(response.data)
          } else {
            vm.asyncFormError = response.data.status + ': ' + response.data.message;
          }
        }).catch(function (error) {
        vm.asyncFormError = errorModel.apiError(error, vm.$router);
        vm.disableForm = false;
      });
    },
    createChartData: function(inputData) {
      const vm = this;
      
      const objectsToChart = [
        {
          id: 'eventsByWeek',
          data: inputData.eventsByWeek,
        },
        {
          id: 'ticketsByWeek',
          data:inputData.ticketsByWeek,
        }
      ];

      objectsToChart.forEach(element => {
        const objectArray = Object.entries(element.data);
        const objectFirst52 = objectArray.slice(0, 51).fromEntries(objectFirst52);
        const objectLast52 = objectArray.slice(-51).fromEntries(objectLast52);
        
        Vue.set(vm.eventStats, element.id, [
          {
            label: 'This year',
            data: objectFirst52,
          },
          {
            label: 'Last year',
            data: objectLast52,
          }
        ]);
      });

      Vue.set(vm.eventStats, 'eventsByYear', inputData.eventsByYear || vm.eventStats.eventsByYear);
      Vue.set(vm.eventStats, 'ticketsByYear', inputData.ticketsByYear || vm.eventStats.ticketsByYear);
    }
  },
  data: function () {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
      venueId: process.env.VUE_APP_VENUE_ID,
      axiosInstance: axios.create({
        baseURL: this.baseUrl,
      }),
      thisYear: new Date().getFullYear(),
      lastYear: new Date().getFullYear() - 1,
      asyncFormError: false,
      disableForm: false,
      userToken: '',
      eventStats: {
        eventsByYear: {},
        eventsByWeek: {},
        ticketsByWeek: {},
        ticketsByYear: {},
        averageEventsPerUser: 0,
        averageMoneyPerEvent: 0,
        averageProfitPerEvent: 0,
      },
      eventsChart: [
        {
          label: 'This year',
          data: [],
        },
        {
          label: 'Last year',
          data: [],
        }
      ]
    }
  }
}
</script>

<style scoped>
  .md-card {
    margin: 20px;
  }

  .md-list-item {
    list-style: none;
  }
</style>
